<template>
  <el-form ref="ruleForm" :model="formModel" :rules="rules" class="level">
    <div class="level__header">
      <div class="level__header-title-wrapper">
        <svg-icon name="arrow-left" class="level__header-arrow" />
        <p class="level__header-title">{{ moduleData.module }}</p>
      </div>
    </div>
    <el-row :gutter="20">
      <el-col :md="19">
        <el-form-item label="Название модуля">
          <el-input v-model="moduleData.module" />
        </el-form-item>
      </el-col>
      <el-col :md="5"></el-col>
    </el-row>
    <el-row :gutter="20" type="flex" align="top" justify="start">
      <el-col :md="19">
        <el-form-item label="День">
          <el-input v-model="formModel.day" />
        </el-form-item>
        <a href="#" class="level__add-btn hidden-md-and-up" @click.prevent="addModule">
          <svg-icon name="plus" class="level__plus-icon" />
          Добавить
        </a>
        <ul class="level__module">
          <li
            v-for="(item, index) in daysData"
            :key="index"
            class="level__module-item"
            @mouseover="isEditable = index"
            @mouseleave="isEditable = null"
          >
            <span>{{ item }}</span>
            <div
              :class="[
                'level__module-item-editable',
                isEditable === index ? 'is-editable-active' : ''
              ]"
            >
              <svg-icon
                name="pencil"
                class="level__module-item-edit"
                @click="editModuleItem(index)"
              />
              <svg-icon
                name="times"
                class="level__module-item-delete"
                @click="deleteModuleItem(index)"
              />
            </div>
          </li>
        </ul>
      </el-col>
      <el-col :md="5" class="hidden-sm-and-down">
        <a href="#" class="level__add-btn" @click.prevent="addModule">
          <svg-icon name="plus" class="level__plus-icon" />
          Добавить
        </a>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
export default {
  name: 'OverviewCourseLevel',
  props: {
    formModel: {
      type: Object,
      required: true
    },
    courseData: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      rules: {},
      isEditable: null
    }
  },
  computed: {
    daysData() {
      return this.courseData?.data[1].children.map(item => item.day)
    },

    moduleData() {
      return this.courseData?.data[1]
    }
  },
  methods: {
    editModuleItem(index) {
      this.courseData.data[1].children = this.moduleData[index]
    },

    deleteModuleItem(index) {
      this.courseData.data[1].children.splice(index, 1)
    },

    addModule() {
      if (!this.formModel.day) {
        return
      }

      this.courseData.data[1].children.push({
        day: this.formModel.day,
        isActive: false,
        children: []
      })
    }
  }
}
</script>

<style scoped lang="scss">
.level {
  &__plus-icon {
    height: 20px;
    width: 20px;
    stroke: $luchmara;
  }

  &__add-btn {
    display: flex;
    align-items: center;
    font-weight: bold;
    margin-top: 34px;
    font-size: 16px;
    color: $luchmara;

    @include sm-and-down {
      margin: 16px 0;
    }
  }

  &__module {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    font-size: 15px;
    color: $deepdark;
  }

  &__module-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 18px;
    padding: 8px;
    min-width: 180px;
    border: 1px solid $whisper;
    border-radius: 4px;
    cursor: pointer;

    @include sm-and-down {
      min-width: 100%;
    }

    &-edit,
    &-delete {
      width: 18px;
      height: 18px;
    }

    &-edit {
      margin-right: 10px;
      stroke: $luchmara;
    }

    &-delete {
      stroke: $red;
    }

    &-editable {
      display: flex;
      visibility: hidden;
      opacity: 0;
    }
  }

  &__header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 24px;
  }

  &__header-title {
    font-weight: bold;
    font-size: 24px;
    text-align: left;
    letter-spacing: 0.35px;
    color: $deepdark;

    @include sm-and-down {
      text-align: center;
    }

    &-wrapper {
      display: flex;
      align-items: center;
    }
  }

  &__header-arrow {
    margin-right: 16px;
    width: 20px;
    height: 20px;
    cursor: pointer;
  }
}

.el-select {
  width: 100% !important;
}

.is-editable-active {
  opacity: 1;
  visibility: visible;
  transition: opacity 1s ease-in-out;
}

::v-deep .el-form-item__label {
  font-size: 12px;
  line-height: 20px;
  padding-left: 6px;
  display: flex;
  color: #b6b9c3;
  margin-bottom: 4px;
}
</style>
